module.exports = __webpack_public_path__ + "img/u1447.20ed7d60.png";